import html5Validation from './html5-validation'
import customInputs from './custom-inputs'
import lazyRecaptcha from './lazy-recaptcha'
import animatedFormSubmission from './animated-form-submission'

const normalResponseHandler = form => {
  const successMessage = form.querySelector('.form-success-message')
  const errorMessage = form.querySelector('.form-error-message')
  if (!form.dataset.originalSuccessMsg) {
    form.dataset.originalSuccessMsg = successMessage?.textContent
  }
  if (!form.dataset.originalErrorMsg) {
    form.dataset.originalErrorMsg = errorMessage?.textContent
  }

  return animatedFormSubmission(form).then(({ error, response, success }) => {
    const json = response.json().catch(e => {
      console.error(e)
      return { result: '' }
    })

    json.then(({ result: message }) => {
      if (response.ok) {
        if (successMessage) {
          successMessage.innerHTML = message || form.dataset.originalSuccessMsg
        }
        success()
      } else {
        if (errorMessage && message) {
          errorMessage.innerHTML = message || form.dataset.originalErrorMsg
        }
        error()
      }
    })
  })
}

const jsonResponseHandler = form => {
  const backendErrors = form.querySelector('[data-backend-errors]')
  const inputs = form.querySelectorAll('input,select,textarea')

  function toggleCommonError(error = false) {
    if (!backendErrors) return
    backendErrors.textContent = error || ''
    backendErrors.style.display = error ? '' : 'none'
  }

  function toggleError(input, error = false) {
    const validateableBlock = input.closest('[data-validateable-block]')
    if (validateableBlock) {
      validateableBlock.classList.toggle('invalid', !!error)

      const serverError = validateableBlock.querySelector(
        '[data-server-input-error]'
      )
      if (serverError) {
        serverError.textContent = error || ''
      }
    }
  }

  inputs.forEach(input => toggleError(input, false))
  toggleCommonError(false)

  animatedFormSubmission(form).then(({ error, response, success }) => {
    if (response.status === 500) {
      toggleCommonError('Unknown Error')
      error()
      return
    }

    response.json().then(json => {
      const { result } = json
      if (result.success) {
        success()
      } else if (typeof result.error === 'string') {
        toggleCommonError(result.error)
        error()
      } else if (
        typeof result.error === 'object' &&
        typeof result.error.contact_form === 'object'
      ) {
        Object.entries(result.error.contact_form).forEach(([key, value]) => {
          const input = form.querySelector(`[name="contact_form[${key}]"]`)
          if (input) {
            toggleError(input, value)
          }
        })
        error()
      } else {
        toggleCommonError('Unknown Error')
        error()
      }
    })
  })
}

const captchaObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const handler =
        'jsonHandler' in entry.target.dataset
          ? jsonResponseHandler
          : normalResponseHandler

      lazyRecaptcha.protectForm(entry.target, handler)
      captchaObserver.unobserve(entry.target)
    }
  })
})

export default page => {
  customInputs(page)

  // validate inputs, call after customInputs because flatpickr creates extra hidden input
  html5Validation(page)

  captchaObserver.disconnect()
  page
    .querySelectorAll('[data-recaptcha-protected]')
    .forEach(form => captchaObserver.observe(form))

  page
    .querySelectorAll(
      '[data-animated-submission]:not([data-recaptcha-protected])'
    )
    .forEach(el => {
      const handler =
        'jsonHandler' in el.dataset
          ? jsonResponseHandler
          : normalResponseHandler
      el.addEventListener('submit', e => {
        e.preventDefault()
        handler(el)
      })
    })
}
